import React from "react";
import { Link } from "react-router-dom";

import { DataElement } from "affinityUI/data/dataElement";
import { List } from "affinityUI/data/list";
import { Grid } from "affinityUI/elements/grid";

import { UsersEntryType } from "./types";

export const Users: React.FC<{ users: UsersEntryType[] }> = ({ users }) => {
  return (
    <List>
      {users.map((user) => (
        <List.Item
          key={user.id}
          actions={
            <Link aria-label={`Edit ${user.lastName}, ${user.firstName}`} to={`${user.id}/edit`}>
              Edit
            </Link>
          }
        >
          <Grid $cols={Grid.cols.EQUAL}>
            <DataElement label={`${user.lastName}, ${user.firstName}`}>{user.email}</DataElement>
            <DataElement label="Site access:">{user.role?.name}</DataElement>
          </Grid>
        </List.Item>
      ))}
    </List>
  );
};
